import React, { FC, ReactElement } from 'react';
import { Tooltip } from '@mui/material';

type Place =
  | 'bottom-end'
  | 'bottom-start'
  | 'bottom'
  | 'left-end'
  | 'left-start'
  | 'left'
  | 'right-end'
  | 'right-start'
  | 'right'
  | 'top-end'
  | 'top-start'
  | 'top';

interface CustomTooltipInfoProps {
  tooltipText: string | number;
  placement?: Place;
  children: ReactElement;
  element?: React.ReactFragment | null;
}

const defaultProps = {
  placement: undefined,
  element: null,
};

export const CustomTooltipInfo: FC<CustomTooltipInfoProps> = ({ tooltipText, placement, children, element }) => {
  return (
    <Tooltip
      title={element || tooltipText}
      className="custom-tooltip"
      placement={placement || 'bottom'}
      enterTouchDelay={0}
      leaveTouchDelay={5000}
      componentsProps={{ tooltip: { className: 'info-tooltip' } }}
    >
      {children}
    </Tooltip>
  );
};

CustomTooltipInfo.defaultProps = defaultProps;
